<template>
  <div class="box" v-if="info">
    <div class="box">
    <FansText :str="sex"></FansText>
    <div class="fans">
        <div id="fanssex" ref="chart"></div>
    </div>
  </div>
  </div>
  <div v-else class="chart">
    <none-data :height="3.5" />
  </div>
</template>

<script>
import FansText from "@/components/FansText.vue";
export default {
    props: {
    info: { type: Object },
  },
  components: { FansText },
  data() {
    return {}
  },
  computed:{
   sex() {
        const obj = this.info
      if(+obj.female > +obj.male) {
          return `女性用户居多，占${(+obj.female * 100).toFixed(2)}%`
      } else {
        return `男性用户居多，占${(+obj.male * 100).toFixed(2)}%`
      }
    }
  },
  methods: {
        // 字体适配
FontChart(res) {
        //获取到屏幕的宽度
        var clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth; 
        if (!clientWidth) return; //报错拦截：
        let fontSize = 10 * (clientWidth / 1920);
        return res * fontSize;
      },
    drawChart() {
      const obj = this.info
      const data = [
      {value:(+obj.male * 100).toFixed(2),name: '男',percent: (+obj.male * 100).toFixed(2) + '%' },
      {value:(+obj.female * 100).toFixed(2),name: '女',percent: (+obj.female * 100).toFixed(2)  + '%'}
      ]
      echarts.init(document.getElementById('fanssex')).setOption({
        legend: { show: false },
         series: [
        {
            name: '粉丝性别分布',
            type: 'pie',
            radius: ['35%', '60%'],
            center: ['50%', '48%'],
            avoidLabelOverlap: true,
            itemStyle: { borderColor: '#fff' },
            color: [
                '#5b9bef',
                '#f1c757',
            ],
            label: {
                // alignTo: 'labelLine', // ! 文字对齐方式
                formatter: function (e) {
                    let {
                        data: { name, percent },
                    } = e;
                    return `{x|}{a|${name}}\n{c|${percent}}`;
                },
                minMargin: 5,
                lineHeight: 15,
                rich: {
                    x: { width: this.FontChart(4), height: this.FontChart(4), backgroundColor: 'inherit', borderRadius: this.FontChart(4) },
                    a: { fontSize: this.FontChart(5), color: 'inherit', padding: [0, 0, 0, 8] },
                    b: { fontSize: this.FontChart(4), align: 'left', color: '#666666', padding: [this.FontChart(6), 0, 0, 0] },
                    c: { fontSize: this.FontChart(6), align: 'left', color: '#666666', padding: [this.FontChart(6), 0, 0, 8] },
                },
            },
            labelLine: {
        lineStyle: {
          width: 2,
        }
      },
            data,
        },
    ],
      })
  }
},
mounted() {
  if(this.info && this.info !== {}) {
    this.drawChart();
  }
  },
}
</script>

<style scoped lang='less'>
#fanssex {
  width: 100%;
  height: 170px;
}

.chart{
  width: 100%;
  height: 195px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
